import { render, staticRenderFns } from "./UiPagination.vue?vue&type=template&id=6f41bc25&"
import script from "./UiPagination.vue?vue&type=script&lang=js&"
export * from "./UiPagination.vue?vue&type=script&lang=js&"
import style0 from "./UiPagination.vue?vue&type=style&index=0&id=6f41bc25&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports